<template>
  <div>
    <div class="title_h1">作業日程詳細</div>
    <vab-collapse-info>
      <template slot="title">基本情報</template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ getFieldValue('blgsnmkj', info) }}
              </div>
              <div class="sub_title">
                （建物CD：{{ getFieldValue('buildingCd', info) }}）
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">商品明細</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ getFieldValue('itmdtlnm', info) }}
              </div>
              <div class="sub_title">
                （商品明細CD：{{ getFieldValue('itemDetailCd', info) }}）
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">点検仕様</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ getFieldValue('workSpecName', info) }}
              </div>
              <div class="sub_title">
                （点検仕様CD：{{ getFieldValue('workSpecCd', info) }}）
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">協力会社</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  info.bcnfrkj
                    ? getFieldValue('bcnfrkj', info)
                    : getFieldValue('supplieName', info)
                }}
              </div>
              <div class="sub_title">
                （協力会社CD：{{
                  info.checkOrganizationCd
                    ? getFieldValue('checkOrganizationCd', info)
                    : getFieldValue('supplierCd', info)
                }}）
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">作業年月</vab-col>
          <vab-col :span="8" class="word_box flex_space flex_center_align">
            <div class="flex_space flex_center_align w100_percentage">
              <div class="flex_auto line_height">
                {{ getFieldValue('workYm', info) }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">発注No連番</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ getFieldValue('acceptOrderNoSeq', info) }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box">発注金額</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_end flex_center_align">
              <div class="line_height">
                {{ moneyFormat(getFieldValue('costPrice', info)) }}
              </div>
            </div>
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>
    <div class="info_main">
      <div
        class="head_box flex_start flex_center_align"
        style="padding-top: 12px"
      >
        <svg-icon icon-class="edit_2_line" class="font_size_24"></svg-icon>
        <span class="hd_title">作業条件内容</span>
      </div>
      <div class="sure_box top_info mtn info_detailed">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">
            <div class="flex_colum">
              <div>作業条件</div>
            </div>
          </vab-col>
          <vab-col :span="20" class="word_box nopadding">
            <vab-row>
              <vab-col class="table_header br" :span="24">日程調整不要</vab-col>
            </vab-row>

            <vab-row>
              <vab-col :span="24" class="word_box8 br flex_center_align">
                {{
                  getEnumTextChange(
                    getFieldValue(
                      'weekdayConditionSpecify.adjustUnnecessaryFlg',
                      info
                    ),
                    $divisions.unnecessaryFlagEnum
                  )
                }}
              </vab-col>
            </vab-row>

            <vab-row>
              <vab-col class="table_header br" :span="12">FM不在の場合</vab-col>
              <vab-col class="table_header" :span="12">要日程調整</vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="12" class="word_box8 br flex_center_align">
                {{
                  isAdjustUnnecessaryFlg
                    ? getEnumTextChange(
                        getFieldValue(
                          'weekdayConditionSpecify.fmAbsentCheckableFlg',
                          info
                        ),
                        $divisions.checkableFlgEnum
                      )
                    : '-'
                }}
              </vab-col>
              <vab-col :span="12" class="word_box8 flex_center_align">
                {{
                  getEnumTextChange(
                    getFieldValue(
                      'weekdayConditionSpecify.needAdjustFlg',
                      info
                    ),
                    $divisions.necessaryFlagEnum
                  )
                }}
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col class="table_header" :span="24">曜日指定</vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="24" class="word_box8 flex_center_align">
                {{
                  getTextValue(
                    getFieldValue(
                      'weekdayConditionSpecify.weekdayLimitContentText',
                      info
                    )
                  )
                }}
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col class="table_header br flex_center_align" :span="12">
                日付指定
              </vab-col>
              <vab-col class="table_header flex_center_align" :span="12">
                時間指定
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="12" class="word_box8 br flex_colum">
                <div class="pre_wrap">
                  {{
                    getTextValue(
                      getFieldValue(
                        'weekdayConditionSpecify.dateLimitContentCanText',
                        info
                      )
                    )
                  }}
                </div>
                <div>
                  {{
                    getTextValue(
                      getFieldValue(
                        'weekdayConditionSpecify.dateLimitContentCannotText',
                        info
                      )
                    )
                  }}
                </div>
              </vab-col>
              <vab-col :span="12" class="word_box8 flex_center_align">
                {{
                  getTextValue(
                    getFieldValue(
                      'weekdayConditionSpecify.timeLimitContentText',
                      info
                    )
                  )
                }}
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col class="table_header br flex_center_align" :span="12">
                お知らせ文
              </vab-col>
              <vab-col class="table_header flex_center_align" :span="12">
                報告書
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col :span="12" class="word_box8 br flex_center_align">
                {{
                  getTextValue(
                    getFieldValue('weekdayConditionSpecify.notifyText', info)
                  )
                }}
              </vab-col>
              <vab-col :span="12" class="word_box8 br flex_center_align">
                {{
                  getTextValue(
                    getFieldValue('weekdayConditionSpecify.reportText', info)
                  )
                }}
              </vab-col>
            </vab-row>
            <vab-row>
              <vab-col class="table_header" :span="24">自由コメント</vab-col>
            </vab-row>
            <vab-row>
              <vab-col
                :span="24"
                class="word_box8 flex_center_align no_border word_break"
              >
                <div class="pre_wrap">
                  {{
                    getTextValue(
                      getFieldValue('weekdayConditionSpecify.freeComment', info)
                    )
                  }}
                </div>
              </vab-col>
            </vab-row>
          </vab-col>
        </vab-row>
      </div>
    </div>
    <div class="info_main">
      <div
        class="head_box flex_start flex_center_align"
        style="padding-top: 12px"
      >
        <svg-icon icon-class="edit_2_line" class="font_size_24"></svg-icon>
        <span class="hd_title">作業日程詳細</span>
      </div>
      <div class="h_date">
        <span class="h_title">作業日程を登録してください</span>
      </div>
      <div v-if="textSwitch">
        ※月を跨ぐ作業の追加が必要な場合は、DLNパートナーサポート課にご連絡ください。
      </div>
      <vab-form ref="form" :model="form" :rules="rulesTable">
        <template v-for="(item, index) in form.list">
          <div
            v-if="item.changeFlg != $divisions.changeFlgEnum.enum_3.value"
            :key="index"
            class="sure_box top_info mtn margin_bottom_12"
          >
            <vab-row class="row_box">
              <vab-col :span="24" class="title_box flex_space">
                <span class="text_8484 font_size">
                  作業No：{{
                    getFieldValue('workingPlanAndResultIdModel.workNo', item)
                  }}
                </span>
                <el-button
                  class="clear_btn margin_top_0 btn_size"
                  :class="{ none_btn: index === 0 || deadlineDisabled }"
                  style="line-height: 1px"
                  :disabled="index === 0"
                  @click="workDel(item, index)"
                >
                  削除
                </el-button>
              </vab-col>
            </vab-row>
            <vab-row class="row_box">
              <vab-col
                :span="24"
                class="word_box border_bottom_none background_f padding_left_6_12 border_right_none"
              >
                <el-row type="flex" class="flex_center_align">
                  <el-col :span="24" class="flex_center_align">
                    <div class="w96 margin_right_8">予定日時</div>
                    <div class="margin_right_16 day_time">
                      <vab-time
                        :prop="'list.' + index + '.workPlanDate'"
                        :ym="info.workYm"
                        :row-item="item"
                        :week-show="true"
                        :work-change="true"
                        :disabled="
                          disabledType(item, 'workTime') || deadlineDisabled
                        "
                        @svgClick="openDay(item, index)"
                        @focusValue="focusValue(index)"
                      />
                    </div>
                    <vab-time-input
                      v-model="item.workPlanStartTime"
                      :disabled="
                        disabledType(item, 'workTime') ||
                        $baseLodash.isEmpty(item.workPlanDate) ||
                        deadlineDisabled
                      "
                      :validate="vaildateTimeStart(item, index)"
                      label-error="予定日時"
                      :row-item="item"
                      class="work_time"
                      :prop="'list.' + index + '.workPlanStartTime'"
                    />
                    <div class="mg8 margin_left_15 margin_right_6">〜</div>
                    <vab-time-input
                      v-model="item.workPlanEndTime"
                      class="work_time"
                      label-error="予定日時"
                      :validate="vaildateTimeEnd(item, index)"
                      :disabled="
                        disabledType(item, 'workTime') ||
                        $baseLodash.isEmpty(item.workPlanDate) ||
                        deadlineDisabled
                      "
                      :row-item="item"
                      :prop="'list.' + index + '.workPlanEndTime'"
                    />
                  </el-col>
                </el-row>
              </vab-col>
              <vab-col
                :span="24"
                class="word_box padding_left_6_12 border_right_none"
                :class="{
                  border_bottom_none: showReasonFunc(item) && index > 0,
                }"
              >
                <el-row type="flex" class="flex_center_align">
                  <el-col :span="24" class="flex_center_align">
                    <div class="w102 margin_right_8">作業日コメント</div>
                    <vab-textarea
                      style="width: 100%"
                      maxlength="1170"
                      :rows="2"
                      :prop="`list.${index}.workDateComment`"
                      :disabled="deadlineDisabled"
                    />
                  </el-col>
                </el-row>
              </vab-col>
              <vab-col
                v-if="showReasonFunc(item) && index > 0"
                :span="24"
                class="word_box padding_left_6_12"
              >
                <el-row type="flex" class="flex_center_align">
                  <el-col :span="24" class="flex_center_align">
                    <div class="w102 margin_right_8">追加理由</div>
                    <vab-textarea
                      :prop="`list.${index}.addDeleteReason`"
                      :rows="2"
                      maxlength="520"
                      class="w100_percentage"
                      :disabled="item.disabled"
                    />
                  </el-col>
                </el-row>
              </vab-col>
            </vab-row>
          </div>
        </template>
        <div class="flex_space mg12">
          <vab-button :btn-list="btnAdd" />
        </div>
        <vab-collapse title="削除済みの作業日程を表示">
          <template v-for="(item, index) in form.list">
            <div
              v-if="item.changeFlg == $divisions.changeFlgEnum.enum_3.value"
              :key="index"
              class="sure_box top_info mtn info_detailed"
            >
              <vab-row class="row_box">
                <vab-col :span="24" class="title_box flex_space">
                  <span class="text_8484 font_size">
                    作業No：{{
                      getFieldValue('workingPlanAndResultIdModel.workNo', item)
                    }}
                  </span>
                  <vab-button
                    :btn-list="makeList"
                    @click.native="workRecover(item, index)"
                  />
                </vab-col>
              </vab-row>
              <vab-row class="row_box">
                <vab-col
                  :span="24"
                  class="word_box border_bottom_none disable_box padding_left_6_12 border_right_none"
                >
                  <el-row type="flex" class="flex_center_align">
                    <el-col :span="24" class="flex_center_align">
                      <div class="w96 margin_right_8">予定日時</div>
                      <div class="margin_right_16 day_time">
                        <vab-time
                          :prop="'list.' + index + '.workPlanDate'"
                          :ym="info.workYm"
                          :week-show="true"
                          :work-change="true"
                          :disabled="true"
                          @svgClick="openDay(item, index)"
                          @focusValue="focusValue(index)"
                        />
                      </div>
                      <vab-time-input
                        v-model="item.workPlanStartTime"
                        class="work_time"
                        disabled
                        :prop="'list.' + index + '.workPlanStartTime'"
                      />
                      <div class="mg8 margin_left_15 margin_right_6">〜</div>
                      <vab-time-input
                        v-model="item.workPlanEndTime"
                        class="work_time"
                        disabled
                        :prop="'list.' + index + '.workPlanEndTime'"
                      />
                    </el-col>
                  </el-row>
                </vab-col>
                <vab-col
                  :span="24"
                  class="word_box disable_box padding_left_6_12 border_right_none"
                  :class="{
                    border_bottom_none:
                      item.addDeleteReason && item.addDeleteReason !== '',
                  }"
                >
                  <el-row type="flex" class="flex_center_align">
                    <el-col :span="24" class="flex_center_align">
                      <div class="w102 margin_right_8">作業日コメント</div>
                      <vab-textarea
                        style="width: 100%"
                        class="w100_percentage"
                        :rows="2"
                        :prop="`list.${index}.workDateComment`"
                        maxlength="1170"
                        disabled
                      />
                    </el-col>
                  </el-row>
                </vab-col>
                <vab-col
                  v-if="item.addDeleteReason && item.addDeleteReason !== ''"
                  :span="24"
                  class="word_box disable_box padding_left_6_12"
                >
                  <el-row type="flex" class="flex_center_align">
                    <el-col :span="24" class="flex_center_align">
                      <div class="w102 margin_right_8">削除理由</div>
                      <vab-textarea
                        :prop="`list.${index}.addDeleteReason`"
                        :rows="2"
                        class="w100_percentage"
                        disabled
                      />
                    </el-col>
                  </el-row>
                </vab-col>
              </vab-row>
            </div>
          </template>
        </vab-collapse>
      </vab-form>
    </div>
    <div class="flex_space flex_center_align mg12">
      <div class="blgsnmkj_class">
        <svg-icon class="svg_icon" icon-class="select_work" />
        <el-link type="primary" @click="openCalentar">カレンダーを表示</el-link>
      </div>
      <vab-button :btn-list="btnList" />
    </div>
    <el-dialog
      class="box_dialog"
      :close-on-press-escape="false"
      custom-class="layout-dialog"
      :title="`作業No:${workNo}`"
      top="5vh"
      :visible.sync="visible"
      append-to-body
      width="580px"
      @close="close"
    >
      <vab-form ref="formAdd" :model="formAdd" :rules="rulesAdd">
        <vab-textarea
          label="削除理由"
          label-width="1"
          placeholder="作業キャンセルのため"
          prop="outlineComment"
          maxlength="520"
          rows="5"
          show-word-limit
        />
      </vab-form>
      <div slot="footer" class="dialog-footer flex_end mg12">
        <div class="flex_start flex_center_align">
          <div class="flex_end mg12">
            <vab-button :btn-list="saveList" />
          </div>
        </div>
      </div>
    </el-dialog>
    <WorkPopupCalender ref="WorkPopupCalender" class="work_popup_calender" />
    <fixedTime ref="fixedTime" @saveData="saveData" />
  </div>
</template>

<script>
  import {
    purchaseOrderDetailRc,
    workPlanDateList,
    workPlanDateUpdate,
  } from '@/api/rc/purchaseDetail'
  import mixins from '@/utils/mixinListPage'

  export default {
    name: 'PWR01G03',
    mixins: [mixins],
    data() {
      return {
        form: {
          list: [],
        },
        rules: {},
        rulesTable: {},
        btnList: [
          {
            name: '更新',
            icon: 'answer',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000409.name}`
            ),
            type: 'button',
            disabled: true,
            hidden: false,
            click: () => {
              let { length: len } = this.getSubmitData()
              if (len > 0) {
                this.$refs['form'].validate((valid) => {
                  if (valid) {
                    this.$confirm({
                      msg: this.format(
                        this.$t(
                          `validateMessage.${this.$messageCode.I00000301.name}`
                        ),
                        '更新'
                      ),
                      yesTex: '更新',
                      yes: async () => {
                        this.updateData()
                      },
                    })
                  } else {
                    return false
                  }
                })
              }
            },
          },
        ],
        visible: false,
        formAdd: {},
        rulesAdd: {},
        saveList: [
          {
            name: 'キャンセル',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
          {
            name: '確定',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: () => {
              this.form.list.forEach((n) => {
                if (n.workingPlanAndResultRcId === this.key) {
                  n.changeFlg = '3'
                  if (this.formAdd?.outlineComment) {
                    n.addDeleteReason = this.formAdd.outlineComment
                  }
                  n.operationType =
                    this.$divisions.operationTypeEnum.enum_D.value
                }
              })
              this.visible = false
            },
          },
        ],
        textSwitch: false,
        btnAdd: [
          {
            name: '作業日追加',
            defaultColor: '#0060C2',
            type: 'plain',
            hidden: false,
            disabled: false,
            click: () => {
              this.addFormList()
            },
          },
        ],
        makeList: [
          {
            name: '復元',
            type: 'plain',
            hidden: false,
            defaultColor: '#0060C2',
            widht: '46',
            minWidht: '46',
            disabled: false,
          },
        ],
        info: {
          weekdayConditionSpecify: {
            adjustUnnecessaryFlg: null,
          },
        },
        purchaseOrderDetailRcId: '',
        key: 0,
        paramsObj: {
          workingPlanAndResultIdModel: {
            workNo: '',
          },
          workDateComment: null,
          workPlanDate: '',
          workPlanEndTime: '',
          workPlanStartTime: '',
          workingPlanAndResultRcId: null,
          changeStatus: this.$divisions.wparStatusEnum.enum_02.value,
          changeRequestFlg:
            this.$divisions.changeRequestFlgEnum.enum_blank.value,
        },
        num: 0,
        visibleWeek: false,
        weekSwitch: '1', // 虚拟的曜日条件
        deleteReasonLength: 0,
        loading: null,
        dayList: [],
        dayIndex: null,
        initTableList: [],
        workNo: null,
        fuList: [],
        deadlineDisabled: false,
        resetCalenderList: null,
      }
    },
    computed: {
      isAdjustUnnecessaryFlg() {
        return this.isEqualCodeEnum(
          this.info.weekdayConditionSpecify?.adjustUnnecessaryFlg,
          this.$divisions.unnecessaryFlagEnum.enum_blank
        )
      },
      vaildateTimeStart() {
        return (row, index) => {
          if (
            !(
              this.disabledType(row, 'workTime') ||
              this.$baseLodash.isEmpty(row.workPlanDate)
            )
          ) {
            this.$set(this.rulesTable, `list.${index}.workPlanStartTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rulesTable, `list.${index}.workPlanStartTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
      vaildateTimeEnd() {
        return (row, index) => {
          if (
            !(
              this.disabledType(row, 'workTime') ||
              this.$baseLodash.isEmpty(row.workPlanDate)
            )
          ) {
            this.$set(this.rulesTable, `list.${index}.workPlanEndTime`, [
              {
                required: true,
                message: this.format(
                  this.$t(
                    `validateMessage.${this.$messageCode.E00000001.name}`
                  ),
                  '予定日時'
                ),
                trigger: 'blur',
              },
            ])
          } else {
            this.$set(this.rulesTable, `list.${index}.workPlanEndTime`, [
              {
                required: false,
                message: null,
              },
            ])
          }
        }
      },
    },
    watch: {
      'form.list': {
        handler() {
          if (this.info?.workYm) {
            let { length: len } = this.getSubmitData()
            if (len > 0) {
              this.btnList[0].disabled = false
            } else {
              this.btnList[0].disabled = true
            }
          }
        },
        deep: true,
      },
    },
    methods: {
      // カレンダーを表示
      openCalentar() {
        this.$refs.WorkPopupCalender.setParamsData({
          ...this.info,
          sectionCd: this.form.list[0]?.workingPlanAndResultIdModel?.sectionCd,
          modeType: 'rc',
          resetCalenderList: this.form.list.map((item) => {
            return {
              ...item,
              day: item?.workPlanDate,
            }
          }),
        })
      },
      addFormList() {
        let obj = { ...this.paramsObj }
        if (this.form.list.length > 0) {
          let data = this.$baseLodash.cloneDeep(this.form.list[0])
          if (data.workingPlanAndResultIdModel) {
            data.workingPlanAndResultIdModel.workNo = null
            data.workingPlanAndResultIdModel.workingPlanAndResultId = null
          }
          data.workPlanDate = null
          data.workPlanStartTime = null
          data.workPlanEndTime = null
          data.workDateComment = null
          data.addDeleteReason = null
          data.operationType = this.$divisions.operationTypeEnum.enum_I.value
          data.workingPlanAndResultId = null
          data.workingPlanAndResultRcId = null
          data.disabled = false
          data.changeStatus = this.$divisions.wparStatusEnum.enum_02.value
          data.changeRequestFlg =
            this.$divisions.changeRequestFlgEnum.enum_blank.value
          this.form.list.push(data)
        } else {
          this.form.list.push(obj)
        }
      },
      // 属性に使用できない制限
      disabledType(data, name) {
        let extentListOne = [
          this.$divisions.wparStatusEnum.enum_02.value,
          this.$divisions.wparStatusEnum.enum_03.value,
          this.$divisions.wparStatusEnum.enum_04.value,
        ]
        let changeRequestListOne = [
          this.$divisions.changeRequestFlgEnum.enum_blank.value,
          this.$divisions.changeRequestFlgEnum.enum_1.value,
          this.$divisions.changeRequestFlgEnum.enum_2.value,
          this.$divisions.changeRequestFlgEnum.enum_3.value,
          this.$divisions.changeRequestFlgEnum.enum_4.value,
        ]
        let extentListTwo = [
          this.$divisions.wparStatusEnum.enum_02.value,
          this.$divisions.wparStatusEnum.enum_03.value,
          this.$divisions.wparStatusEnum.enum_04.value,
          this.$divisions.wparStatusEnum.enum_05.value,
        ]
        let changeRequestListTwo = [
          this.$divisions.changeRequestFlgEnum.enum_blank.value,
        ]
        if (name === 'answerDeadline') {
          return (
            !extentListOne.includes(data.changeStatus) ||
            !changeRequestListOne.includes(data.changeRequestFlg)
          )
        } else if (name === 'workTime') {
          if (!data?.workPlanDate) {
            data.workPlanStartTime = null
            data.workPlanEndTime = null
          }
          let temp =
            !extentListTwo.includes(data.changeStatus) ||
            !changeRequestListTwo.includes(data.changeRequestFlg)
          return temp
        }
      },
      // 判断ルーティング
      async fetchData() {
        this.purchaseOrderDetailRcId =
          this.$route.query?.purchaseOrderDetailRcId
        if (this.purchaseOrderDetailRcId) {
          this.getList(this.purchaseOrderDetailRcId)
        }
      },
      // データの取得
      async getList(id) {
        this.loading = this.$baseColorfullLoading()
        try {
          const res = await purchaseOrderDetailRc(id)
          if (res?.deadline) {
            // now > deadline true
            this.deadlineDisabled = this.$dayjs(res?.deadline).isBefore(
              this.$dayjs(),
              'date'
            )
            this.btnAdd[0].disabled = this.deadlineDisabled
            this.makeList[0].disabled = this.deadlineDisabled
          }
          let list = await workPlanDateList(id)
          list.forEach((itm) => {
            if (itm.addDeleteReason !== '') {
              itm.disabled = true
            }
          })
          this.initTableList = this.$baseLodash.cloneDeep(list)
          list.filter((item) => {
            if (item.workPlanDate) {
              item.workPlanDate = this.$dayjs(item.workPlanDate).format('DD')
            }
          })
          this.form.list = this.$baseLodash.cloneDeep(list)
          this.dayList = this.form.list
            .filter((itm) => itm.workPlanDate)
            .map((v) => v.workPlanDate)
          this.$nextTick(() => {
            this.info = res
          })
          this.getWeek(
            res.weekdayConditionSpecifyModel,
            res.weekdayConditionSpecifySpotModel
          )
        } finally {
          this.loading.close()
        }
      },
      // 日曜日の値を判断する
      async getWeek(
        weekdayConditionSpecifyModel,
        weekdayConditionSpecifySpotModel
      ) {
        if (!this.$baseLodash.isNull(weekdayConditionSpecifySpotModel)) {
          this.weekSwitch = '3'
        } else if (!this.$baseLodash.isNull(weekdayConditionSpecifyModel)) {
          this.weekSwitch = '2'
        } else {
          this.weekSwitch = '1'
        }
      },
      // 弾枠を閉じる
      close() {
        this.$refs.formAdd.resetFields()
        this.visible = false
        this.deleteReasonLength = 0
      },
      // 削除
      workDel(item, index) {
        if (this.deadlineDisabled) return
        if (!item.workingPlanAndResultRcId) {
          this.form.list.splice(index, 1)
        } else {
          this.visible = true
          this.key = item.workingPlanAndResultRcId
          this.workNo = item?.workingPlanAndResultIdModel?.workNo
        }
      },
      // 復元
      workRecover(item) {
        if (this.deadlineDisabled) return
        this.form.list.forEach((itm) => {
          if (itm.workingPlanAndResultRcId === item.workingPlanAndResultRcId) {
            itm.changeFlg = '1'
            itm.addDeleteReason = ''
            itm.operationType = this.$divisions.operationTypeEnum.enum_U.value
            itm.disabled = false
            itm.recover = true
          }
        })
      },
      getSubmitData() {
        let chuanList = this.$baseLodash.cloneDeep(this.form.list)
        chuanList.filter((item) => {
          if (item.workPlanDate) {
            let day =
              item.workPlanDate.length > 4
                ? this.$dayjs(item.workPlanDate).format('DD')
                : (item.workPlanDate =
                    parseInt(item.workPlanDate) < 10
                      ? '0' + parseInt(item.workPlanDate)
                      : item.workPlanDate)
            item.workPlanDate = this.info.workYm + '/' + day
          }
          if (item.workPlanStartTime && item.workPlanStartTime.length == 5) {
            item.workPlanStartTime = item.workPlanStartTime + ':00:000'
          }
          if (item.workPlanEndTime && item.workPlanEndTime.length == 5) {
            item.workPlanEndTime = item.workPlanEndTime + ':00:000'
          }
          this.$delete(item, 'disabled')
        })
        let list = this.compareArr({
          originArr: this.initTableList,
          targetArr: chuanList,
          identifyKey: 'workingPlanAndResultRcId',
          keys: [
            'workPlanDate',
            'workPlanEndTime',
            'workPlanStartTime',
            'workDateComment',
            'addDeleteReason',
            'changeFlg',
          ],
        })

        list.filter((item) => {
          this.form.list.filter((son) => {
            if (
              son.workingPlanAndResultRcId == item.workingPlanAndResultRcId &&
              son.operationType ==
                this.$divisions.operationTypeEnum.enum_D.value
            ) {
              item.operationType =
                this.$divisions.operationTypeEnum.enum_D.value
            }
          })
        })
        list.filter((item) => {
          if (
            this.isEqualCodeEnum(
              item.operationType,
              this.$divisions.operationTypeEnum.enum_U
            ) &&
            item.recover
          ) {
            item.changeFlg = this.$divisions.changeFlgEnum.enum_3.value
          }
        })
        let paramsList = list.filter((item) => item.operationType)
        return paramsList
      },
      // 作業日詳細（日程追加） 作業日追加/更新
      async updateData() {
        this.loading = this.$baseColorfullLoading()
        let data = {
          purchaseOrderDetailRc: this.info, // purchaseOrderDetailRc
          workingPlanAndResultList: this.getSubmitData(), // List<WorkingPlanAndResultRc>
        }
        try {
          const res = await workPlanDateUpdate(data) // this.$route.query?.purchaseOrderDetailRcId
          if (res || res === 0) {
            this.msgSuccess(
              this.$t(`validateMessage.${this.$messageCode.I00000409.name}`)
            )
            this.$closePage(this.$route.name)
            this.$routerPushAndReload({
              name: this.$route.query?.fromRoute,
              refresh: this.$route.query?.fromRoute,
            })
          }
        } finally {
          if (this.loading != null) {
            this.loading.close()
          }
        }
      },
      showReasonFunc(row) {
        if (!row.operationType && !row.addDeleteReason) {
          return false
        } else {
          return true
        }
      },
      // 開く予定日時
      openDay(item, index) {
        if (
          item.changeFlg === '3' ||
          this.disabledType(item, 'workTime') ||
          this.deadlineDisabled
        )
          return
        this.num = index
        let cloneData = this.$baseLodash.cloneDeep(item)
        cloneData = {
          ...cloneData,
          weekdayConditionSpecifyModel: this.info.weekdayConditionSpecifyModel,
          weekdayConditionSpecifySpotModel:
            this.info.weekdayConditionSpecifySpotModel,
          requestYearMonth: this.formatDateTime(
            this.$baseLodash.toString(item.workYm),
            this.$const.dateFormatYYYYMMDD
          ),
          day: item?.workPlanDate,
          startTime: this.formatTimeMsel(item?.workPlanStartTime, 'HH:mm'),
          endTime: this.formatTimeMsel(item?.workPlanEndTime, 'HH:mm'),
        }
        this.$refs.fixedTime.setParamsData(cloneData)
      },
      // 保存＃ホゾン＃予定日時
      saveData(val) {
        if (!val) return
        this.form.list[this.num].workPlanDate = val?.day
        this.form.list[this.num].workPlanStartTime = val?.startTime
        this.form.list[this.num].workPlanEndTime = val?.endTime
      },
      sendValue(value) {
        if (value.length === 2 && this.dayList.includes(value)) {
          this.form.list[this.dayIndex].workPlanDate = value.slice(0, 1)
        } else if (value.length === 1 && this.dayList.includes(value)) {
          this.form.list[this.dayIndex].workPlanDate = ''
        }
      },
      focusValue(index) {
        this.dayIndex = index
      },
    },
  }
</script>

<style lang="scss" scoped>
  .info_detailed {
    margin-top: 16px;
  }

  .flex_space {
    justify-content: space-between !important;
  }

  .block_set {
    display: block !important;
  }

  .disable_box {
    background: #f7f7f7;
    color: #a1a1a1;
  }

  .recover_btn {
    width: auto;
    height: 32px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #0060c2 !important;
    color: #0060c2 !important;
    font-size: 14px;
    font-weight: 500;
    padding: 0px 7px !important;

    &:hover {
      background: #ffffff;
    }
  }

  .none_btn {
    color: #a1a1a1 !important;
    background: #efefef !important;
    border-color: #cecece !important;
  }

  .work_time {
    ::v-deep .el-input__inner {
      text-align: center;
      width: 60px;
    }
  }
  .work_time {
    ::v-deep .el-form-item__content {
      width: 60px;
    }
  }

  .btn_size {
    width: 46px !important;
    height: 28px !important;
  }

  .clear_btn:hover {
    background: #ffffff;
  }

  .day_time {
    ::v-deep {
      .el-input__inner {
        width: 40px;
      }
    }
  }

  ::v-deep {
    .btnname {
      font-size: 13px !important;
    }

    .el-input__inner {
      padding: 6px 11px !important;
    }

    .el-dialog__title {
      color: #003350;
    }

    .el-textarea__inner {
      color: #000000;

      &::placeholder {
        color: #000000;
        font-size: 14px;
        font-weight: 400;
      }
    }

    .el-dialog__body {
      padding-bottom: 0px;
      padding-top: 15px;
    }

    .el-dialog__footer {
      padding-top: 0px;
      border-top: 0px !important;
    }
  }
</style>
